export default __webpack_public_path__ + "static/media/cctv.31e488a7.png";